<template>
  <div>
    <div class="pre-header">
      <div class="container">
        <div class="row">
          <div class="col-xs-6">
            <ul class="list-unstyled list-inline">
              <li>
                <i class="iconfont icon-dianhua"></i
                ><span style="margin-left: 5px"
                  >86-13500099000 / 852-90980107</span
                >
              </li>
              <li>
                <i class="iconfont icon-youjian"></i
                ><span style="margin-left: 5px">samuel.yuen@tricool.com</span>
              </li>
            </ul>
          </div>
          <div class="col-xs-6 langs-box">
            <Language-List
              class="ist-unstyled list-inline pull-right"
            ></Language-List>
            <!-- <ul class="list-unstyled list-inline pull-right">
							
						</ul> -->
          </div>
        </div>
      </div>
    </div>
    <div class="header">
      <div class="container" style="background-image: url()">
        <div class="row">
          <div class="col-md-6 col-xs-8">
            <a class="site-logo">
              <img height="57" src="../assets/tricool/logo.png" />
            </a>
          </div>
          <div class="col-md-6 col-xs-4">
            <a href="javascript:void(0);" class="mobi-toggler" style="padding:5.4px" @click="showMenu()"
            >
			<svg t="1628907648776" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4165" width="20" height="20"><path d="M275.2 134c77.68 0 140.88 63.2 140.88 140.88v141.2H275.2c-37.73 0-73.19-14.68-99.86-41.35-26.66-26.66-41.34-62.12-41.34-99.85C134 197.2 197.34 134 275.2 134m0-63C162.39 71 71 162.4 71 274.88c0 112.8 91.39 204.2 204.2 204.2h203.88v-204.2C479.08 162.4 387.69 71 275.2 71zM416.08 607.92V748.8c0 37.73-14.68 73.19-41.35 99.86-26.66 26.66-62.12 41.34-99.85 41.34C197.2 890 134 826.66 134 748.8c0-77.68 63.2-140.88 140.88-140.88h141.2m63-63h-204.2C162.4 544.92 71 636.31 71 748.8 71 861.61 162.4 953 274.88 953c112.8 0 204.2-91.39 204.2-204.2V544.92zM748.8 607.92c37.73 0 73.19 14.68 99.86 41.35 26.66 26.66 41.35 62.12 41.35 99.85C890 826.8 826.66 890 748.8 890c-77.68 0-140.88-63.2-140.88-140.88v-141.2H748.8m0-63H544.92v204.2C544.92 861.6 636.31 953 748.8 953 861.61 953 953 861.6 953 749.12c0-112.81-91.39-204.2-204.2-204.2zM749.12 134C826.8 134 890 197.34 890 275.2c0 77.68-63.2 140.88-140.88 140.88h-141.2V275.2c0-37.73 14.68-73.19 41.35-99.86 26.66-26.66 62.12-41.34 99.85-41.34m0-63c-112.8 0-204.2 91.39-204.2 204.2v203.88h204.2C861.6 479.08 953 387.69 953 275.2 953 162.39 861.6 71 749.12 71z" p-id="4166"></path></svg>
            </a>
            <div class="header-navigation pull-right font-transform-inherit" :style="menu?'display:block':'display:none'">
              <ul>
                <li
                  v-for="(item, i) in navItems"
                  :key="i"
                  :class="i == currtabs ? 'active' : ''"
                >
                  <!-- @click="changeActive(i)" -->
                  <router-link :to="'/web/' + item.target">{{
                    $Lang.L(item.name)
                  }}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import LanguageSwitch from '../../../components/language-switch.vue'
import LanguageList from "../../../components/language-list.vue";
export default {
  props: ["currtabs"],
  components: { LanguageList },
  data() {
    return {
      navItems: [
        {
          name: { en: "Home", cn: "主页", hk: "主頁" },
          target: "index",
          icon: "",
        },
        {
          name: { en: "Products", cn: "产品中心", hk: "產品中心" },
          target: "products",
          icon: "",
        },
        {
          name: { en: "News", cn: "公司新闻", hk: "公司新聞" },
          target: "corpUpdate",
          icon: "",
        },
        {
          name: { en: "Solutions", cn: "解决方案", hk: "解決方案" },
          target: "applicationField",
          icon: "",
        },
        {
          name: { en: "About", cn: "关于我们", hk: "關於我們" },
          target: "contactUS",
          icon: "",
        },
      ],
      currNav: 0,
	  menu:true  
    };
  },
  watch:{

  },
  mounted(){
	  window.innerWidth<=1024?this.menu=false:''  
  },
  methods: {
    changeActive(key) {
      this.currtabs = key;
      // this.$data.currNav=key
    },
	showMenu(){
		this.menu=!this.menu;
	}
  },
};
</script>
<style scoped="scoped">
ul {
  margin-top: 0;
  margin-bottom: 0;
}
.pre-header {
  color: #bdc0c3;
}
@media (max-width: 1024px){
	.header .header-navigation{
		display: block;
	}
}
/* @media screen and (min-height:0px) and (max-height:640px) {
		.ivu-dropdown-menu .ivu-dropdown-item{
			padding-left:0px;
		}
	} */
</style>
